import DefaultDashboardLayout from '@/modules/dashboardParent/components/DefaultDashboardLayout';
import AvailableProtocolList from '@/modules/dashboardParent/components/AvailableProtocolList';
import AvailableProtocolLayout from '@/modules/dashboardParent/components/AvailableProtocolLayout';
import AppealsLayout from '@/modules/dashboardParent/components/AppealsLayout';
import UndesirableBehaviorLayout from '@/modules/dashboardParent/components/UndesirableBehaviorLayout';
import ActiveProtocolView from '@/modules/dashboardParent/components/ActiveProtocolView';
import CurrentStage from '@/modules/dashboardParent/components/CurrentStage';
import MandStage from '@/modules/dashboardParent/components/MandReactionStage';
import ChainStage from '@/modules/dashboardParent/components/ChainReactionStage';
import ShapingStage from "@/modules/dashboardParent/components/ShapingCurrentStage"
import stageList from '@/modules/dashboardParent/components/ReactionStagesList';
import MasteringStage from '@/modules/dashboardParent/components/MasteringStage';
import MaintainStage from '@/modules/dashboardParent/components/MaintainStage';
import RotationStage from '@/modules/dashboardParent/components/RotationStage';
import FluencyStage from '@/modules/dashboardParent/components/FluencyStage';
import ChooseStage from '@/modules/dashboardParent/components/ChooseStage';
import ChooseUSDStage from '@/modules/dashboardParent/components/ChooseUSDStage';
import CurrentStageResults from '@/modules/dashboardParent/components/CurrentStageResults';
import isAuthorized from '../../../router/hooks/isAuthorized';
import isMensurationForbidden from '../../../router/hooks/isMensurationForbidden';
import canViewAssignedProtocol from '../routes/hooks/canViewAssignedProtocol';
import ConflictLayout from '@/modules/dashboardParent/components/ConflictLayout';
import MasteringStageUSD from '@/modules/dashboardParent/components/MasteringStageUSD';
import MaintainStageUSD from '@/modules/dashboardParent/components/MaintainStageUSD';
import CurrentStageLayout from '@/modules/dashboardParent/components/CurrentStageLayout';
import PecsStage from '@/modules/dashboardParent/components/PecsReactionStage';
import PecsStageWithoutDiscrimination from '@/modules/dashboardParent/components/PecsWithoutDiscriminationReactionStage';
import PecsWithDiscriminationStage from '@/modules/dashboardParent/components/PecsWithDiscriminationStage';
import PecsWithItemsStage from '@/modules/dashboardParent/components/PecsWithItemsStage';


import multiguard from 'vue-router-multiguard';
import hasAccess from '../../dro/routes/hooks/hasAccess';

export default [
  {
    path: '/dashboard',
    component: DefaultDashboardLayout,
    beforeEnter: isAuthorized,
    children: [
      {
        path: '/available-protocols/',
        name: 'available-protocols',
        component: AvailableProtocolList,
        beforeEnter: isAuthorized,
      },

      {
        path: '/appeals',
        name: 'appeals',
        component: AppealsLayout,
        props: true,
        beforeEnter: isAuthorized,
      },

      {
        path: '/undesirable-behavior',
        name: 'undesirable-behavior',
        component: UndesirableBehaviorLayout,
        props: true,
        beforeEnter: isAuthorized,
      },
    ],
  },


  {
    path: '/available-protocols/',
    component: AvailableProtocolLayout,
    beforeEnter: isAuthorized,
    key: 'available-protocol:protocolId',
    props: true,
    children: [
      {
        path: ':protocolId/protocol',
        name: 'protocol-item',
        props: true,
        component: ActiveProtocolView,
        beforeEnter: isAuthorized,
        key: 'available-protocol:protocolId',
      },

      {
        path: '/current-stage',
        name: 'current-stage-layout',
        component: CurrentStageLayout,
        props: true,
        beforeEnter: multiguard([isAuthorized, isMensurationForbidden, canViewAssignedProtocol]),
        key: 'available-protocol:protocolId',
        children: [
          {
            path: '/available-protocols/:protocolId/current-stage/:stageId',
            name: 'current-stage',
            props: true,
            component: CurrentStage,
            key: 'available-protocol:protocolId',
          },
          {
            path: '/available-protocols/:protocolId/stages',
            name: 'stage-list',
            props: true,
            component: stageList,
            key: 'available-protocol:protocolId',
          },
          {
            path: '/available-protocols/:protocolId/mand-stage/:stageId',
            name: 'mand-stage-current',
            props: true,
            component: MandStage,
            key: 'available-protocol:protocolId',
          },
          {
            path: '/available-protocols/:protocolId/chain-stage/:stageId',
            name: 'chain-stage-current',
            props: true,
            component: ChainStage,
            key: 'available-protocol:protocolId',
          },

          {
            path: '/available-protocols/:protocolId/shaping-stage/:stageId',
            name: 'shaping-stage-current',
            props: true,
            component: ShapingStage,
            key: 'available-protocol:protocolId',
          },


          {
            path: '/available-protocols/:protocolId/choose-stage/:stageId',
            name: 'choose-stage',
            props: true,
            component: ChooseStage,
            key: 'available-protocol:protocolId',
          },

          {
            path: '/available-protocols/:protocolId/:stageId/mastering-stage/:phaseId',
            name: 'mastering-stage',
            props: true,
            component: MasteringStage,
            key: 'available-protocol:protocolId',
          },

          {
            path: '/available-protocols/:protocolId/:stageId/rotation-stage/:phaseId',
            name: 'rotation-stage',
            props: true,
            component: RotationStage,
            key: 'available-protocol:protocolId',
          },

          {
            path: '/available-protocols/:protocolId/:stageId/fluency-stage/:phaseId',
            name: 'fluency-stage',
            props: true,
            component: FluencyStage,
            key: 'available-protocol:protocolId',
          },
          {
            path: '/available-protocols/:protocolId/:stageId/maintain-stage/:phaseId',
            name: 'maintain-stage',
            props: true,
            component: MaintainStage,
            key: 'available-protocol:protocolId',
          },

          {
            path: '/available-protocols/:protocolId/stage',
            name: 'pecs-stage',
            props: true,
            component: PecsStage,
            key: 'available-protocol:protocolId',
          },

          {
            path: '/available-protocols/:protocolId/stage-pecs-with-discrimination/:stageId',
            name: 'pecs-with-discrimination-stage',
            props: true,
            component: PecsWithDiscriminationStage,
            key: 'available-protocol:protocolId',
          },

          {
            path: '/available-protocols/:protocolId/stage-pecs-with-items/',
            name: 'pecs-with-items-stage',
            props: true,
            component: PecsWithItemsStage,
            key: 'available-protocol:protocolId',
          },

          {
            path: '/available-protocols/:protocolId/stage-pecs/',
            name: 'pecs-stage-without-discrimination',
            props: true,
            component: PecsStageWithoutDiscrimination,
            key: 'available-protocol:protocolId',
          },

          {
            path: '/available-protocols/:protocolId/choose-usd/:stageId',
            name: 'choose-usd',
            props: true,
            component: ChooseUSDStage,
            key: 'available-protocol:protocolId',
          },

          {
            path: '/available-protocols/:protocolId/mastering-stage-usd/:stageId',
            name: 'mastering-stage-usd',
            props: true,
            component: MasteringStageUSD,
            key: 'available-protocol:protocolId',
          },

          {
            path: '/available-protocols/:protocolId/maintain-stage-usd/:stageId',
            name: 'maintain-stage-usd',
            props: true,
            component: MaintainStageUSD,
            key: 'available-protocol:protocolId',
          },
        ]
      },





      {
        path: ':protocolId/results',
        name: 'results',
				props: true,
        component: CurrentStageResults,
        beforeEnter: multiguard([isAuthorized, canViewAssignedProtocol]),
        key: 'available-protocol:protocolId',
      },
    ],
  },
  {
    path: '/clients/:clientId/conflict-list/:sessionId',
    name: 'conflict-list',
    component: ConflictLayout,
    props: true,
    beforeEnter: multiguard([isAuthorized, isMensurationForbidden, hasAccess]),
  },
];



// WEBPACK FOOTER //
// ./src/modules/dashboardParent/routes/index.js